import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const Toolbar = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '16px',
}));

export const Select = styled('select')(() => ({
  fontFamily: 'inherit',
  fontSize: '13px',
  fontWeight: 500,
  color: protoColors.textPrimary,
  padding: '8px 12px',
  borderRadius: '10px',
  border: `1px solid ${protoColors.border}`,
  backgroundColor: protoColors.surface,
  cursor: 'pointer',
}));

export const StatsRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '12px',
  gridTemplateColumns: 'repeat(4, 1fr)',
  marginBottom: '20px',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}));

export const Stat = styled(Box)(() => ({
  backgroundColor: protoColors.surfaceSubtle,
  borderRadius: '10px',
  padding: '12px 14px',
}));

export const StatLabel = styled(Typography)(() => ({
  fontSize: '11px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
  color: protoColors.textMuted,
}));

export const StatValue = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>(({ color }) => ({
  fontSize: '22px',
  fontWeight: 800,
  color: color ?? protoColors.textPrimary,
}));

export const FunnelWrap = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
}));

export const StageRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
}));

export const StageHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '13.5px',
  color: protoColors.textPrimary,
  '& strong': {
    fontWeight: 700,
  },
}));

export const BarTrack = styled(Box)(() => ({
  height: '26px',
  borderRadius: '8px',
  backgroundColor: protoColors.surfaceSubtle,
  overflow: 'hidden',
}));

export const BarFill = styled(Box)(() => ({
  height: '100%',
  borderRadius: '8px',
  background: `linear-gradient(90deg, ${protoColors.purpleDark}, ${protoColors.purple})`,
  minWidth: '2px',
  transition: 'width 0.3s ease',
}));
